export enum ItaNonProdPolicy {
    ReadNonProd = 'ReadNonProd',
    WriteNonProd = 'WriteNonProd',
    AdminNonProd = 'AdminNonProd',
    NoAccessNonProd = 'NoAccessNonProd'
}